export type PeriodData = { value: string; label: string };

const START_DATE = new Date("2024-01-01");
const END_DATE = new Date();

export type HalfYear = "2024-H1" | "2024-H2" | "2025-H1" | "2025-H2";
export type Quarter =
  | "2024-Q1"
  | "2024-Q2"
  | "2024-Q3"
  | "2024-Q4"
  | "2025-Q1"
  | "2025-Q2"
  | "2025-Q3"
  | "2025-Q4";

type HalfYearData = { value: HalfYear; label: string };
type QuarterData = { value: Quarter; label: string };

export type YearMonth =
  | "2024-01"
  | "2024-02"
  | "2024-03"
  | "2024-04"
  | "2024-05"
  | "2024-06"
  | "2024-07"
  | "2024-08"
  | "2024-09"
  | "2024-10"
  | "2024-11"
  | "2024-12"
  | "2025-01"
  | "2025-02"
  | "2025-03"
  | "2025-04"
  | "2025-05"
  | "2025-06"
  | "2025-07"
  | "2025-08"
  | "2025-09"
  | "2025-10";
type YearMonthData = { value: YearMonth; label: string };

export interface StartEndDate {
  startDate: string;
  endDate: string;
}

const halfAndQuarterMaker = (
  start: Date,
  end: Date
): (HalfYearData | QuarterData)[] => {
  const result: (HalfYearData | QuarterData)[] = [];
  const current = new Date(start);

  while (current <= end) {
    const year = current.getFullYear();
    const month = current.getMonth() + 1;

    // 분기 추가
    if (month === 1 || month === 4 || month === 7 || month === 10) {
      const quarter = `${Math.ceil(month / 3)}` as Quarter;
      result.push({
        value: `${year}-Q${quarter}` as Quarter,
        label: `${year.toString().slice(2)}년 ${quarter}분기`,
      });
    }

    // 반기 추가
    if (month === 4 || month === 10) {
      const half = month === 4 ? "H1" : "H2";
      result.push({
        value: `${year}-${half}` as HalfYear,
        label: `${year.toString().slice(2)}년 ${
          half === "H1" ? "상반기" : "하반기"
        }`,
      });
    }

    current.setMonth(current.getMonth() + 1);
  }

  return result;
};

export const HALF_AND_QUARTERS: (HalfYearData | QuarterData)[] =
  halfAndQuarterMaker(START_DATE, END_DATE);

const monthMaker = (start: Date, end: Date): YearMonthData[] => {
  const result: YearMonthData[] = [];
  const current = new Date(start);

  while (current <= end) {
    const year = current.getFullYear();
    const month = (current.getMonth() + 1).toString().padStart(2, "0");
    result.push({
      value: `${year}-${month}` as YearMonth,
      label: `${year.toString().slice(2)}년 ${parseInt(month, 10)}월`,
    });
    current.setMonth(current.getMonth() + 1);
  }

  return result;
};

export const MONTHS: YearMonthData[] = monthMaker(START_DATE, END_DATE);

// 다음 달까지 포함한 월 목록 (급여관리·기타세금 — 다음 달 지급분을 미리 볼 수 있게).
// 기본 선택 월은 여전히 이번 달(MONTHS의 마지막)을 쓴다.
// 끝 날짜를 1일 자정으로 두면 START_DATE(UTC 파싱 → 로컬 09시)와 비교해 빠지므로 15일로 둔다.
const NEXT_MONTH_END = new Date(
  END_DATE.getFullYear(),
  END_DATE.getMonth() + 1,
  15
);

export const MONTHS_WITH_NEXT: YearMonthData[] = monthMaker(
  START_DATE,
  NEXT_MONTH_END
);
